import { render, staticRenderFns } from "./brandRxCount.vue?vue&type=template&id=14898940"
import script from "./brandRxCount.vue?vue&type=script&lang=js"
export * from "./brandRxCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports